import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // prepare template parameters
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs
      .send(
        "service_ddsddo8", // replace with EmailJS service ID
        "template_rg4sa2f", // replace with EmailJS template ID
        templateParams,
        "YJJEDiqSEVrNQkqb8" // replace with EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Thank you for contacting us! We will get back to you soon.");
          setFormData({ name: "", email: "", phone: "", message: "" });
        },
        (error) => {
          console.error(error.text);
          alert("Oops! Something went wrong. Please try again later.");
        }
      );
  };

  return (
    <div className="contact-page">
      <header className="contact-header">
        <h1>Contact Us</h1>
        <p>
          Have a question or need a construction quote? Get in touch with us – we’d love to hear from you!
        </p>
      </header>

      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Your Phone"
            value={formData.phone}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Send Message</button>
        </form>

        {/* Your company info & map */}
        <div className="contact-info">
          <h2>Our Office</h2>
          <p>🏢 Aarrcon Engineers</p>
          <p>📍 292, Anjanadri Complex,5th Floor,11th Block</p>
          <p> Naagarabhaavi, Bengaluru, Karnataka 560072</p>
          <p>Mob: 8277091898</p>
          <p>✉️ sales@aarrcon.com</p>
          
          {/* <div className="map-container">
            <iframe
              title="company-location"
              src="https://www.google.com/maps/place/12%C2%B058'22.5%22N+77%C2%B030'39.6%22E/@12.9729123,77.5084273,17z/data=!3m1!4b1!4m4!3m3!8m2!3d12.9729123!4d77.5110022?hl=en&entry=ttu&g_ep=EgoyMDI1MDkxNS4wIKXMDSoASAFQAw%3D%3D"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div> */}
          <div className="map-container">
  <a
    href="https://www.google.com/maps/place/12%C2%B058'22.5%22N+77%C2%B030'39.6%22E/@12.9729123,77.5084273,17z/data=!3m1!4b1!4m4!3m3!8m2!3d12.9729123!4d77.5110022?hl=en&entry=ttu&g_ep=EgoyMDI1MDkxNS4wIKXMDSoASAFQAw%3D%3D"
    target="_blank"
    rel="noopener noreferrer"
    style={{ display: "block" }}
  >
    <iframe
      title="company-location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.631063582835!2d77.5087996!3d12.9731305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3dd3f9d6a85d%3A0x78e27b5d1f3b12ad!2sAnjanadri%20Complex%2C%2011th%20Block%2C%20Nagarabhavi%2C%20Bengaluru%2C%20Karnataka%20560072!5e0!3m2!1sen!2sin!4v1694800000000"
      width="100%"
      height="250"
      style={{ border: 0, pointerEvents: "none" }} // disables scrolling inside iframe
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </a>
</div>

        </div>
      </div>
    </div>
  );
}

export default Contact;
